/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { UserCompactDTO } from './user-compact-dto';


export interface PagedModelUserCompactDTO { 
    content?: Array<UserCompactDTO>;
    page?: PageMetadata;
}

